import ModuleUtils from 'components/Modules/utils';
import KEYWORDS from '../../keywords';

const { ROUTES } = KEYWORDS;

export const openModuleItem = ({ history, moduleItemKey, closeDatasource }) => {
	const route = ModuleUtils.getRouteFromModuleItemKey(moduleItemKey);
	history.push(`${ROUTES.FEED.PATH}/${route}`);
	closeDatasource();
};

export const returnToModuleList = ({ history, resetActions }) => {
	resetActions.forEach(resetAction => resetAction());
	history.push(ROUTES.FEED.PATH);
};
